import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CustomDateInputComponent} from "./custom-date-input.component";
import {FormFieldModule} from "../../../../../modules/core/component/form-field/form-field.module";
import {SelectFilterModule} from "../../../select-filter/select-filter.module";
import {DatePickerModule} from "../../../date-picker/date-picker.module";
import {SelectModule} from "../../../select/select.module";
import {ButtonModule} from "../../../../../modules/core/component/button/button.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        FormFieldModule,
        SelectFilterModule,
        DatePickerModule,
        SelectModule,
        ButtonModule,
    ],
    declarations: [
        CustomDateInputComponent,
    ],
    exports: [
        CustomDateInputComponent,
    ],
})
export class CustomDateInputModule {}
